document.documentElement.classList.add('js');
const $ = (s, root = document) => root.querySelector(s);
const $$ = (s, root = document) => [...root.querySelectorAll(s)];
const discount = (price, compare) => compare > price && compare > 0 ? Math.round((compare - price) * 100 / compare) : 0;
function setMenu(open) { const toggle=$('[data-menu-toggle]');if(toggle){toggle.textContent=open?'×':'☰';toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');} $('[data-navigation]')?.classList.toggle('is-open', open); document.body.classList.toggle('menu-open', open); const backdrop = $('[data-menu-backdrop]'); if(backdrop) backdrop.hidden = !open; $('[data-menu-toggle]')?.setAttribute('aria-expanded', String(open)); if(open){ activateNav($('.nav-item.is-mobile-active')?.dataset.navIndex||'0'); $('[data-nav-tab][aria-selected="true"]')?.focus(); }else if(document.activeElement?.closest('[data-navigation]'))$('[data-menu-toggle]')?.focus(); }
$('[data-menu-toggle]')?.addEventListener('click', () => setMenu(!$('[data-navigation]')?.classList.contains('is-open')));
$$('[data-menu-close],[data-menu-backdrop]').forEach(b => b.addEventListener('click', () => setMenu(false)));
document.addEventListener('keydown', e => { if(e.key !== 'Escape') return; const search=$('.header-search.is-mobile-open'); if(search){search.classList.remove('is-mobile-open');$('[data-search-toggle]')?.setAttribute('aria-expanded','false');$('[data-search-toggle]')?.focus();} const openDetails=$$('.nav-details[open]');openDetails.forEach(details=>{details.open=false;});if(openDetails.length)$('summary',openDetails[0])?.focus();setMenu(false);$('[data-image-dialog]')?.close(); });
$$('[data-home-tab]').forEach(button => button.addEventListener('click', () => {const root = button.closest('[data-product-tabs]'); $$('[data-home-tab]', root).forEach(b => {const active=b===button;b.classList.toggle('is-active',active);b.setAttribute('aria-selected',String(active));}); $$('[data-home-panel]',root).forEach(p => p.hidden = p.dataset.homePanel !== button.dataset.homeTab); }));
$$('[data-shop-by-activity]').forEach(section => {
  const tabs = $$('[data-activity-tab]', section);
  const panels = $$('[data-activity-panel]', section);
  const previous = $('[data-activity-previous]', section);
  const next = $('[data-activity-next]', section);
  const activePanel = () => panels.find(panel => !panel.hidden);
  const syncArrows = () => {
    const panel = activePanel();
    if (!panel) return;
    const maxScroll = panel.scrollWidth - panel.clientWidth;
    previous.disabled = panel.scrollLeft <= 1;
    next.disabled = maxScroll <= 1 || panel.scrollLeft >= maxScroll - 1;
  };
  const activateTab = (button, focus = false) => {
    tabs.forEach(tab => {
      const active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach(panel => {
      panel.hidden = panel.dataset.activityPanel !== button.dataset.activityTab;
      if (!panel.hidden) panel.scrollTo({ left: 0, behavior: 'auto' });
    });
    syncArrows();
    if (focus) button.focus();
  };
  const scrollPanel = direction => {
    const panel = activePanel();
    const firstCard = panel && $('[data-activity-card]', panel);
    if (!panel || !firstCard) return;
    const gap = Number.parseFloat(getComputedStyle(panel).columnGap) || Number.parseFloat(getComputedStyle(panel).gap) || 0;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    panel.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
  };
  tabs.forEach(button => {
    button.addEventListener('click', () => activateTab(button));
    button.addEventListener('keydown', event => {
      const current = tabs.indexOf(button);
      const target = event.key === 'ArrowRight' ? tabs[(current + 1) % tabs.length]
        : event.key === 'ArrowLeft' ? tabs[(current - 1 + tabs.length) % tabs.length]
          : event.key === 'Home' ? tabs[0]
            : event.key === 'End' ? tabs.at(-1)
              : null;
      if (!target) return;
      event.preventDefault();
      activateTab(target, true);
    });
  });
  panels.forEach(panel => {
    panel.addEventListener('scroll', () => requestAnimationFrame(syncArrows), { passive: true });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      scrollPanel(event.key === 'ArrowRight' ? 1 : -1);
    });
  });
  previous.addEventListener('click', () => scrollPanel(-1));
  next.addEventListener('click', () => scrollPanel(1));
  window.addEventListener('resize', syncArrows, { passive: true });
  syncArrows();
});
$$('[data-home-ambassadors]').forEach(section => {
  const slides = $$('[data-ambassador-slide]', section);
  const tabs = $$('[data-ambassador-tab]', section);
  const previous = $('[data-ambassador-previous]', section);
  const next = $('[data-ambassador-next]', section);
  if (slides.length < 2 || !previous || !next) return;
  let activeIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
  const activate = (index, focus = false) => {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== activeIndex; });
    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === activeIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    previous.disabled = activeIndex === 0;
    next.disabled = activeIndex === slides.length - 1;
    if (focus) tabs[activeIndex].focus();
  };
  previous.addEventListener('click', () => activate(activeIndex - 1));
  next.addEventListener('click', () => activate(activeIndex + 1));
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', event => {
      const targetIndex = event.key === 'ArrowRight' ? (index + 1) % tabs.length
        : event.key === 'ArrowLeft' ? (index - 1 + tabs.length) % tabs.length
          : event.key === 'Home' ? 0
            : event.key === 'End' ? tabs.length - 1
              : null;
      if (targetIndex === null) return;
      event.preventDefault();
      activate(targetIndex, true);
    });
  });
  let touchStartX = null;
  section.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
  section.addEventListener('touchend', event => {
    if (touchStartX === null) return;
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 48) activate(activeIndex + (distance < 0 ? 1 : -1));
    touchStartX = null;
  }, { passive: true });
  activate(activeIndex);
});
const cookiePanel=$('[data-cookie-panel]');
if(cookiePanel){
  try{cookiePanel.hidden=sessionStorage.getItem('shopify_cookie_banner_dismissed')==='true';}catch{cookiePanel.hidden=false;}
  $('[data-cookie-accept]',cookiePanel)?.addEventListener('click',()=>{
    try{sessionStorage.setItem('shopify_cookie_banner_dismissed','true');}catch{}
    cookiePanel.hidden=true;
  });
}
let cartRequestInFlight=false;
function setCartButtonsBusy(busy){
  cartRequestInFlight=busy;
  $$('[data-cart-submit]').forEach(button=>{
    button.disabled=busy||button.dataset.cartVariantReady!=='true';
  });
}

function updateProductSections(){
  $$('[data-product-section]').forEach(section=>{
    const variants=JSON.parse($('[data-product-variants]',section).textContent);
    const fields=$$('[data-option-index]',section);
    let currentVariant=variants.find(variant=>String(variant.id)===$('[data-variant-id]',section).value);
    function update(){
      const options=fields.map(field=>$('input:checked',field)?.value);
      fields.forEach((field,index)=>{$('[data-option-label]',field).textContent=options[index]||'';});
      currentVariant=variants.find(variant=>variant.options.every((option,index)=>option===options[index]));
      const add=$('[data-add-to-bag]',section);
      add.dataset.cartVariantReady=String(Boolean(currentVariant?.available));
      add.disabled=cartRequestInFlight||!currentVariant?.available;
      add.textContent=currentVariant?(currentVariant.available?'ADD TO BAG':'SOLD OUT'):'UNAVAILABLE';
      if(!currentVariant)return;
      $('[data-variant-id]',section).value=currentVariant.id;
      const prices=$('[data-pdp-prices]',section);
      prices.replaceChildren();
      const price=document.createElement('span');
      price.className='price';
      price.textContent=currentVariant.priceFormatted;
      prices.append(price);
      const savings=discount(currentVariant.price,currentVariant.compare);
      if(savings){price.classList.add('price--sale');const compare=document.createElement('s');compare.className='compare-price';compare.textContent=currentVariant.compareFormatted;prices.append(compare);}
      const badge=$('[data-pdp-badge]',section);
      badge.hidden=!savings;
      badge.textContent=savings+'% OFF';
      const target=$('[data-gallery-image="'+currentVariant.imageId+'"]',section);
      if(target){const gallery=$('[data-gallery]',section);gallery.prepend(target);gallery.scrollLeft=0;}
      const url=new URL(location.href);
      url.searchParams.set('variant',currentVariant.id);
      history.replaceState({},'',url);
    }
    fields.forEach(field=>field.addEventListener('change',update));
    const add=$('[data-add-to-bag]',section);
    if(add)add.dataset.cartVariantReady=String(Boolean(currentVariant?.available));
  });
}
updateProductSections();

const addedBag=$('[data-added-bag]');
if(addedBag){
  const cartRoot=addedBag.dataset.cartRoot||window.Shopify?.routes?.root||'/';
  const addedItem=$('[data-added-bag-item]',addedBag);
  const recommendationsStatus=$('[data-added-bag-status]',addedBag);
  const recommendationsViewport=$('[data-added-bag-viewport]',addedBag);
  const recommendationsTrack=$('[data-added-bag-track]',addedBag);
  const previousButton=$('[data-added-bag-previous]',addedBag);
  const nextButton=$('[data-added-bag-next]',addedBag);
  const emptyRecommendations=$('[data-added-bag-empty]',addedBag);
  const currency=addedBag.dataset.currency||'USD';
  const fallbackRecommendations=JSON.parse($('[data-added-bag-fallback-products]',addedBag).textContent);
  let focusReturn=null;
  let recommendationsRequest=0;

  function cartMoney(cents){
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(Number(cents||0)/100);
  }

  function syncCart(cart){
    $$('[data-cart-count]').forEach(count=>count.textContent=cart.item_count);
    $('[data-added-bag-count]',addedBag).textContent=cart.item_count;
    const threshold=Number(addedBag.dataset.freeDeliveryThreshold);
    const delivery=$('[data-added-bag-delivery]',addedBag);
    if(threshold>0){
      delivery.hidden=false;
      delivery.textContent=cart.total_price>=threshold
        ? 'You’ve qualified for FREE Standard delivery'
        : `Spend ${cartMoney(threshold-cart.total_price)} more for FREE Standard delivery`;
    }else{
      delivery.hidden=true;
      delivery.textContent='';
    }
  }

  function renderAddedItem(item){
    addedItem.replaceChildren();
    const imageUrl=item.featured_image?.url||item.image||'';
    if(imageUrl){
      const image=document.createElement('img');
      image.className='added-bag__item-image';
      image.src=imageUrl;
      image.alt=item.featured_image?.alt||item.product_title||item.title||'';
      image.width=260;
      image.height=260;
      image.loading='eager';
      addedItem.append(image);
    }
    const details=document.createElement('div');
    details.className='added-bag__item-details';
    const title=document.createElement('h3');
    title.textContent=item.product_title||item.title||'';
    details.append(title);
    const optionValues=(item.options_with_values||[]).map(option=>option.value).filter(value=>value&&value!=='Default Title');
    const variantValues=optionValues.length?optionValues:(item.variant_options||[]).filter(value=>value&&value!=='Default Title');
    if(!variantValues.length&&item.variant_title&&item.variant_title!=='Default Title')variantValues.push(...item.variant_title.split(/\s+\/\s+/));
    if(variantValues.length){
      const variant=document.createElement('p');
      variant.className='added-bag__item-variant';
      variant.textContent=variantValues.join(' | ');
      details.append(variant);
    }
    const price=document.createElement('p');
    price.className='added-bag__item-price';
    price.textContent=cartMoney(item.final_price??item.price);
    details.append(price);
    addedItem.append(details);
  }

  function recommendationImage(product,variant){
    const source=variant?.image||variant?.featured_image||product.image||product.featured_image;
    return typeof source==='string'?source:source?.src||source?.url||'';
  }

  function normalizeRecommendation(product){
    const variants=(product.variants||[]).map(variant=>({
      id:variant.id,
      title:variant.title||'',
      options:variant.options||[variant.option1,variant.option2,variant.option3].filter(Boolean),
      available:Boolean(variant.available),
      price:Number(variant.price||0),
      image:recommendationImage(product,variant)
    }));
    return {
      id:String(product.id),
      title:product.title||'',
      url:product.url||`/products/${product.handle}`,
      type:product.type||product.product_type||'',
      image:recommendationImage(product),
      options:product.options||product.options_with_values?.map(option=>option.name)||[],
      variants
    };
  }

  function updateRecommendationArrows(){
    const maxScroll=recommendationsViewport.scrollWidth-recommendationsViewport.clientWidth;
    previousButton.disabled=recommendationsViewport.scrollLeft<=1;
    nextButton.disabled=maxScroll<=1||recommendationsViewport.scrollLeft>=maxScroll-1;
  }

  function createRecommendationCard(rawProduct){
    const product=normalizeRecommendation(rawProduct);
    const variants=product.variants.filter(variant=>variant.available);
    if(!variants.length)return null;
    const card=document.createElement('article');
    card.className='added-bag-card';
    card.dataset.recommendationCard='';
    card.dataset.variants=JSON.stringify(variants.map(variant=>({options:variant.options,available:variant.available})));
    const link=document.createElement('a');
    link.className='added-bag-card__image-link';
    link.href=product.url;
    link.setAttribute('aria-label',product.title);
    if(product.image){
      const image=document.createElement('img');
      image.className='added-bag-card__image';
      image.src=product.image;
      image.alt=product.title;
      image.width=800;
      image.height=800;
      image.loading='lazy';
      link.append(image);
    }else{
      const emptyImage=document.createElement('span');
      emptyImage.className='added-bag-card__image-placeholder';
      emptyImage.setAttribute('aria-hidden','true');
      link.append(emptyImage);
    }
    card.append(link);

    const choices=document.createElement('div');
    choices.className='added-bag-card__choices';
    const optionNames=product.options.filter(name=>name&&name!=='Title');
    const needsOptions=optionNames.length>0&&!(optionNames.length===1&&variants.length===1&&variants[0].title==='Default Title');
    const selectedOptions=[];
    if(needsOptions){
      optionNames.forEach((name,index)=>{
        const label=document.createElement('label');
        label.className='added-bag-card__choice';
        const labelText=document.createElement('span');
        labelText.textContent=name;
        const select=document.createElement('select');
        select.setAttribute('aria-label',`${product.title}: ${name}`);
        const placeholder=document.createElement('option');
        placeholder.value='';
        placeholder.textContent=`SELECT ${name}`;
        select.append(placeholder);
        [...new Set(variants.map(variant=>variant.options[index]).filter(Boolean))].forEach(value=>{
          const option=document.createElement('option');
          option.value=value;
          option.textContent=value;
          select.append(option);
        });
        selectedOptions[index]='';
        select.addEventListener('change',()=>{
          selectedOptions[index]=select.value;
          activeVariant=selectedOptions.every(Boolean)
            ?variants.find(variant=>variant.options.every((value,optionIndex)=>value===selectedOptions[optionIndex]))
            :null;
          updateCardVariant();
        });
        label.append(labelText,select);
        choices.append(label);
      });
    }
    if(needsOptions)card.append(choices);

    let activeVariant=needsOptions?null:variants[0];
    const meta=document.createElement('div');
    meta.className='added-bag-card__meta';
    const title=document.createElement('a');
    title.className='added-bag-card__title';
    title.href=product.url;
    title.textContent=product.title.toUpperCase();
    const type=document.createElement('p');
    type.className='added-bag-card__type';
    type.textContent=product.type.toUpperCase();
    meta.append(title,type);
    const purchase=document.createElement('div');
    purchase.className='added-bag-card__purchase';
    const price=document.createElement('span');
    price.className='added-bag-card__price';
    const form=document.createElement('form');
    form.dataset.cartAdd='';
    const variantInput=document.createElement('input');
    variantInput.type='hidden';
    variantInput.name='id';
    variantInput.value=activeVariant?.id||'';
    const quantity=document.createElement('input');
    quantity.type='hidden';
    quantity.name='quantity';
    quantity.value='1';
    const add=document.createElement('button');
    add.type='submit';
    add.className='added-bag-card__add';
    add.dataset.cartSubmit='';
    add.dataset.cartVariantReady=String(Boolean(activeVariant));
    add.textContent='+ ADD TO BAG';
    add.disabled=!activeVariant;
    form.append(variantInput,quantity,add);
    const error=document.createElement('p');
    error.className='added-bag-card__error';
    error.setAttribute('role','alert');
    error.dataset.cartError='';
    error.hidden=true;
    purchase.append(price,form);
    card.append(meta,purchase,error);

    function updateCardVariant(){
      variantInput.value=activeVariant?.id||'';
      add.dataset.cartVariantReady=String(Boolean(activeVariant));
      add.disabled=cartRequestInFlight||!activeVariant;
      price.textContent=cartMoney(activeVariant?.price??variants[0].price);
      if(activeVariant){
        const image=$('.added-bag-card__image',card);
        if(image&&activeVariant.image)image.src=activeVariant.image;
      }
    }
    updateCardVariant();
    return card;
  }

  function renderRecommendations(products){
    recommendationsTrack.replaceChildren();
    const cards=products.map(createRecommendationCard).filter(Boolean);
    recommendationsStatus.hidden=true;
    emptyRecommendations.hidden=cards.length>0;
    recommendationsViewport.hidden=cards.length===0;
    previousButton.disabled=true;
    nextButton.disabled=cards.length===0;
    recommendationsTrack.append(...cards);
    recommendationsViewport.scrollLeft=0;
    requestAnimationFrame(updateRecommendationArrows);
  }

  async function loadRecommendations(productId,addedProductId){
    const requestId=++recommendationsRequest;
    recommendationsStatus.textContent='Finding complementary products…';
    recommendationsStatus.hidden=false;
    emptyRecommendations.hidden=true;
    recommendationsViewport.hidden=true;
    const complementary=[];
    if(productId){
      const url=new URL(`${cartRoot}recommendations/products.json`,location.origin);
      url.searchParams.set('product_id',productId);
      url.searchParams.set('limit','8');
      url.searchParams.set('intent','complementary');
      const response=await fetch(url,{headers:{Accept:'application/json'}}).catch(()=>null);
      if(response?.ok){
        const data=await response.json().catch(()=>({}));
        complementary.push(...(data.products||[]));
      }
    }
    if(requestId!==recommendationsRequest)return;
    const seen=new Set([String(addedProductId)]);
    const merged=[...complementary,...fallbackRecommendations].filter(product=>{
      const id=String(product.id);
      if(seen.has(id)||!product.available&&product.available!==undefined)return false;
      seen.add(id);
      return true;
    }).slice(0,8);
    renderRecommendations(merged);
  }

  function showAddedBag(item,cart,trigger){
    renderAddedItem(item);
    if(cart)syncCart(cart);
    if(!addedBag.open){
      focusReturn=trigger?.closest('[data-added-bag]')
        ?$('[data-cart-count]')?.closest('a')
        :trigger||$('[data-cart-count]')?.closest('a');
      addedBag.showModal();
      $('[data-added-bag-close]',addedBag).focus();
    }else $('[data-added-bag-close]',addedBag).focus();
    void loadRecommendations(item.product_id||item.productId,item.product_id||item.productId);
  }

  addedBag.addEventListener('close',()=>{
    if(focusReturn?.isConnected)focusReturn.focus({preventScroll:true});
    else $('[data-cart-count]')?.closest('a')?.focus({preventScroll:true});
    focusReturn=null;
  });
  addedBag.addEventListener('click',event=>{
    if(event.target===addedBag)addedBag.close();
  });
  $('[data-added-bag-close]',addedBag).addEventListener('click',()=>addedBag.close());
  recommendationsViewport.addEventListener('scroll',updateRecommendationArrows,{passive:true});
  recommendationsTrack.addEventListener('load',updateRecommendationArrows,true);
  recommendationsViewport.addEventListener('keydown',event=>{
    if(event.key!=='ArrowLeft'&&event.key!=='ArrowRight')return;
    event.preventDefault();
    recommendationsViewport.scrollBy({left:(event.key==='ArrowRight'?1:-1)*recommendationsViewport.clientWidth*.8,behavior:'smooth'});
  });
  previousButton.addEventListener('click',()=>recommendationsViewport.scrollBy({left:-recommendationsViewport.clientWidth*.8,behavior:'smooth'}));
  nextButton.addEventListener('click',()=>recommendationsViewport.scrollBy({left:recommendationsViewport.clientWidth*.8,behavior:'smooth'}));
  window.addEventListener('resize',updateRecommendationArrows,{passive:true});
}

document.addEventListener('submit',async event=>{
  const form=event.target.closest('form[data-cart-add]');
  if(!form)return;
  event.preventDefault();
  const button=$('[data-cart-submit]',form);
  if(cartRequestInFlight||!button||button.disabled)return;
  const error=$('[data-product-error]',form)||$('[data-cart-error]',form.closest('[data-recommendation-card]'));
  if(error){error.hidden=true;error.textContent='';}
  setCartButtonsBusy(true);
  try{
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(`${root}cart/add.js`,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    const result=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(result.description||result.message||'Unable to add this item. Please try again.');
    const cartResponse=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}}).catch(()=>null);
    const cart=cartResponse?.ok?await cartResponse.json().catch(()=>null):null;
    showAddedBag(result,cart,event.submitter||button);
  }catch(reason){
    if(error){error.textContent=reason.message||'Unable to add this item. Please try again.';error.hidden=false;}
  }finally{
    setCartButtonsBusy(false);
    updateProductSections();
  }
});

$$('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{const dialog=$('[data-image-dialog]');$('[data-enlarged-image]',dialog).src=$('img',button).src;dialog.showModal();}));
$('[data-image-close]')?.addEventListener('click',()=>$('[data-image-dialog]').close());
$('[data-image-dialog]')?.addEventListener('click',e=>{if(e.target===e.currentTarget)e.currentTarget.close();});
$('[data-filter-toggle]')?.addEventListener('click',e=>{const form=$('#CollectionFilters');form.hidden=!form.hidden;e.currentTarget.setAttribute('aria-expanded',String(!form.hidden));});
$('[data-sort-by]')?.addEventListener('change',e=>{const url=new URL(location.href);url.searchParams.set('sort_by',e.target.value);url.searchParams.delete('page');location.href=url.href;});


function activateNav(index){$$('[data-nav-tab]').forEach(button=>button.setAttribute('aria-selected',String(button.dataset.navTab===index)));$$('[data-nav-index]').forEach(item=>{const active=item.dataset.navIndex===index;item.classList.toggle('is-mobile-active',active);if(matchMedia('(max-width:989px)').matches){const details=$('details',item);if(details)details.open=active;}});}
$$('[data-nav-tab]').forEach(b=>b.addEventListener('click',()=>activateNav(b.dataset.navTab)));
$('[data-search-toggle]')?.addEventListener('click',e=>{const search=$('.header-search');const open=search.classList.toggle('is-mobile-open');e.currentTarget.setAttribute('aria-expanded',String(open));if(open)$('input[type=search]',search).focus();});
const desktopNav=matchMedia('(min-width:990px)');
const closeTimers=new WeakMap();
$$('.nav-details').forEach(details=>{
  const summary=$('summary',details);
  details.addEventListener('toggle',()=>summary?.setAttribute('aria-expanded',String(details.open)));
  summary?.addEventListener('click',event=>{if(!desktopNav.matches)return;event.preventDefault();details.open=true;});
  details.addEventListener('pointerenter',()=>{
    if(!desktopNav.matches)return;
    clearTimeout(closeTimers.get(details));
    $$('.nav-details').forEach(other=>{if(other!==details)other.open=false;});
    details.open=true;
  });
  details.addEventListener('pointerleave',()=>{
    if(!desktopNav.matches)return;
    clearTimeout(closeTimers.get(details));
    closeTimers.set(details,setTimeout(()=>{details.open=false;},160));
  });
  details.addEventListener('focusin',()=>{
    if(!desktopNav.matches)return;
    clearTimeout(closeTimers.get(details));
    $$('.nav-details').forEach(other=>{if(other!==details)other.open=false;});
    details.open=true;
  });
  details.addEventListener('focusout',event=>{
    if(details.contains(event.relatedTarget))return;
    details.open=false;
  });
});
document.addEventListener('pointerdown',event=>{
  if(!desktopNav.matches||event.target.closest('[data-header]'))return;
  $$('.nav-details[open]').forEach(details=>{details.open=false;});
});
desktopNav.addEventListener('change',()=>{setMenu(false);$$('.nav-details').forEach(details=>{details.open=false;});});

const heroVideoFrames=$$('[data-hero-frame]');
if(heroVideoFrames.length){
  const mobileVideoQuery=matchMedia('(max-width:749px)');
  const reducedMotionQuery=matchMedia('(prefers-reduced-motion: reduce)');
  const vimeoScript=document.createElement('script');
  vimeoScript.src='https://player.vimeo.com/api/player.js';
  vimeoScript.async=true;
  vimeoScript.addEventListener('load',()=>{
    const syncHeroVideo=()=>heroVideoFrames.forEach(frame=>{
      const active=frame.classList.contains('hero-video__frame--mobile')===mobileVideoQuery.matches;
      const media=frame.closest('[data-video-media]');
      if(!active||reducedMotionQuery.matches){frame.removeAttribute('src');media.classList.remove('is-playing');return;}
      if(frame.hasAttribute('src'))return;
      frame.addEventListener('load',()=>{
        const player=new window.Vimeo.Player(frame);
        player.on('playing',()=>media.classList.add('is-playing'));
        player.on('pause',()=>media.classList.remove('is-playing'));
        player.on('error',()=>media.classList.remove('is-playing'));
        player.play().catch(()=>media.classList.remove('is-playing'));
      },{once:true});
      frame.src=frame.dataset.videoSrc;
    });
    syncHeroVideo();
    mobileVideoQuery.addEventListener('change',syncHeroVideo);
    reducedMotionQuery.addEventListener('change',syncHeroVideo);
  });
  document.head.append(vimeoScript);
}
